import React, { useState, useEffect } from "react";
import SectionWrapper from "../components/SectionWrapper";
import WhychooseUs from "../components/WhychooseUs";
import KeyStrengths from "../components/KeyStrengths";
import { Link } from "react-router-dom";

const HomePage = () => {
  const images = [
    "/ImageAndVideo/image/careimg1.jpg",
    "/ImageAndVideo/image/careimg2.jpeg",
    "/ImageAndVideo/image/careimg3.jpeg",
    "/ImageAndVideo/image/careimg4.jpg",
    "/ImageAndVideo/image/careimg5.jpg",
  ];

  // Duplicate only the first image → allows smooth infinite loop
const loopImages = [...images, images[0]];

  const [current, setCurrent] = useState(0);
  const [transition, setTransition] = useState(true);

  // Auto sliding
useEffect(() => {
  const interval = setInterval(() => {
    setCurrent(prev => prev + 1);
  }, 3000);

  return () => clearInterval(interval);
}, []);

  // Reset after reaching the duplicate slide
 useEffect(() => {
  if (current === loopImages.length - 1) {
    // Wait for slide animation (700ms) → then jump instantly
    const timer = setTimeout(() => {
      setTransition(false);
      setCurrent(0);

      // FIX: re-enable transition on the *next frame*
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setTransition(true);
        });
      });
    }, 700);

    return () => clearTimeout(timer);
  }
}, [current]);

  return (
    <main className="mt-16 text-gray-800 font-sans">

      {/* HERO SECTION */}
      <SectionWrapper
        className="relative bg-maroon text-white overflow-hidden lg:h-[95vh]"
        aria-labelledby="hero-heading"
      >
        <div className="absolute inset-0">
          <video
            className="w-full h-full object-cover opacity-50"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            disablePictureInPicture
            controls={false}
            controlsList="nodownload noplaybackrate nofullscreen"
            poster="/ImageAndVideo/Video/carev1-thumbnail.jpg"
          >
            <source src="/ImageAndVideo/Video/carev1.mp4" type="video/mp4" />
          </video>
        </div>

        <div className="relative z-10 grid md:grid-cols-2 items-center py-24 lg:px-6 px-2">
          <div>
            <h1
              id="hero-heading"
              className="text-2xl md:text-5xl font-bold leading-tight mb-6"
            >
              Complete healthcare for senior citizens in India
            </h1>
            <p className="text-xl text-gray-100 mb-8 leading-relaxed">
              India’s NRI-Focused Eldercare Platform — Delivering primary
              preventive and assistive healthcare with compassion.
            </p>

            <Link
              to="/contact"
              className="bg-gold text-maroon hover:bg-gold-light px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300"
            >
              Contact Us to Know More
            </Link>
          </div>

          {/* IMAGE SLIDER */}
          <div className="relative w-full flex flex-col items-center justify-center overflow-hidden py-6">
            <div className="relative w-full max-w-md md:max-w-lg overflow-hidden rounded-3xl shadow-lg">
              <div
                className={`flex ${
                  transition ? "transition-transform duration-700 ease-in-out" : ""
                }`}
                style={{ transform: `translateX(-${current * 100}%)` }}
              >
                {loopImages.map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt="slider-img"
                    className="w-full object-cover flex-shrink-0 rounded-3xl"
                    width={480}
                    height={320}
                  />
                ))}
              </div>
            </div>

            {/* DOT INDICATORS */}
            <div className="flex mt-4 space-x-2">
              {images.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`w-5 h-5 rounded-full transition-all duration-300 ${
                    current % images.length === i
                      ? "bg-white border-4 border-maroon"
                      : "bg-white opacity-60"
                  }`}
                ></button>
              ))}
            </div>
          </div>
        </div>
      </SectionWrapper>

      {/* BODY SECTIONS */}
      {/* <SectionWrapper className="bg-white text-center py-20 px-4 md:px-16">
        <h2 className="text-3xl md:text-4xl font-bold text-maroon mb-6">
          Who We Are
        </h2>
        <p className="text-lg text-gray-700 max-w-5xl mx-auto leading-relaxed">
          AegisCare provides medical, preventive and homecare assistance for
          senior citizens...
        </p>
      </SectionWrapper> */}

      <KeyStrengths />
      <WhychooseUs />

      <SectionWrapper className="bg-maroon text-center text-white py-16">
        <h2 className="text-3xl font-bold mb-10">
          Ready to Ensure the Best Care for Your Loved Ones?
        </h2>
        <Link
          to="/contact"
          className="bg-gold text-maroon hover:bg-gold-light px-8 py-4 rounded-full font-semibold text-lg"
        >
          Contact Us to Know More
        </Link>
      </SectionWrapper>

    </main>
  );
};

export default HomePage;
